import { Container, Row, Col, Button, Form, Spinner } from 'react-bootstrap'
import { StepHeader } from '../StepHeader/StepHeader'
import { StepperComponent } from '../../Components/StepperComponent/StepperComponent'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../Hooks/useLocalStorage'
import './Step2.scss'
import config from '../../config'

export const Step2 = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [workfrontApiKey, setWorkfrontApiKey] = useLocalStorage('workfrontApiKey', '')
  const [workfrontBaseUrl, setWorkfrontBaseUrl] = useLocalStorage('workfrontBaseUrl', '')
  const [workfrontAuthenticated, setWorkfrontAuthenticated] = useState(false)
  const [connectionFailed, setConnectionFailed] = useState(false)
  const [authenticationFailed, setAuthenticationFailed] = useState(false)

  const checkApiKeys = async () => {
    try {
      setLoading(true)
      const data = await fetch(`${config.BACKEND_URL}/checkBothTokens`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      }).then(async (data) => {
        const resp = await data.json()
        if (resp.success) {
          setWorkfrontAuthenticated(true)
        } else {
          setWorkfrontAuthenticated(false)
        }
        setLoading(false)
        return resp.success
      })
      return data
    } catch (error) {
      setLoading(false)
      console.log('Connection error', error)
      setConnectionFailed(true)
    }
  }

  const fetchWorkfrontApiKey = async () => {
    if (workfrontBaseUrl !== '' && workfrontApiKey !== '') {
      try {
        setLoading(true)
        const resp = await fetch(`${config.BACKEND_URL}/getWorkfrontAccessToken`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            baseUrl: workfrontBaseUrl,
            apiKey: workfrontApiKey,
          }),
        })
        const data = await resp.json()
        if (data.success) {
          setWorkfrontAuthenticated(true)
          window.location.reload()
        } else {
          setAuthenticationFailed(true)
        }
        setWorkfrontBaseUrl('')
        setWorkfrontApiKey('')
        setLoading(false)
      } catch (error) {
        console.log('Error while authenticating', error)
        setConnectionFailed(true)
        setLoading(false)
      }
    }
  }

  const deleteCookie = async () => {
    setLoading(true)
    try {
      const resp = await fetch(`${config.BACKEND_URL}/deleteCookie?wf=true`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      setLoading(false)
      if (resp.status === 200) {
        setWorkfrontAuthenticated(false)
      }
      return resp.status
    } catch (error) {
      setLoading(false)
      console.log('Connection error', error)
      setConnectionFailed(true)
    }
  }

  useEffect(() => {
    checkApiKeys()
  }, [])

  if (loading) {
    return (
      <Container>
        <Row>
          <StepHeader />
        </Row>
        <Row>
          <Col>
            <StepperComponent currentStep={2} />
          </Col>
        </Row>
        <Row className="d-flex align-items-center justify-content-center">
          <Spinner animation="grow" variant="dark" />
        </Row>
      </Container>
    )
  }

  return (
    <Container>
      <Row>
        <StepHeader />
      </Row>
      <Row>
        <Col>
          <StepperComponent currentStep={2} />
        </Col>
      </Row>
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-flex-start mt-2'}>
          <div>Workfront Base Url</div>
        </Col>
        <Col md={6}>
          <Form>
            <Form.Control
              className={'mb-3'}
              placeholder={'https://<company>.my.workfront.com'}
              onChange={(e) => {
                setWorkfrontBaseUrl(e.target.value)
              }}
              disabled={workfrontAuthenticated}
            ></Form.Control>
          </Form>
        </Col>
      </Row>
      <Row className={'d-flex mb-3 justify-content-center'}>
        <Col md={2} className={'align-self-flex-start mt-2'}>
          <div>Workfront Api Key</div>
        </Col>
        <Col md={6}>
          <Form>
            <Form.Control
              className={'mb-3'}
              type={'text'}
              onChange={(e) => {
                setWorkfrontApiKey(e.target.value)
              }}
              disabled={workfrontAuthenticated}
            ></Form.Control>
          </Form>
          <div style={{ color: '#96938D' }}>*User needs to be an Adminstrator*</div>
        </Col>
      </Row>
      <Row className={'justify-content-center align-items-center'}>
        <Col xs={12} md={6} className={'text-center text-md-end mb-3 mt-5'}>
          <Button
            onClick={async () => {
              await fetchWorkfrontApiKey()
              setWorkfrontApiKey('')
              setWorkfrontBaseUrl('')
            }}
            disabled={workfrontAuthenticated}
            style={{
              width: '14rem',
              backgroundColor: `${workfrontAuthenticated ? 'green' : ''}`,
              color: `${workfrontAuthenticated ? 'white' : ''}`,
            }}
            className={'testConnectionButton'}
          >
            {!workfrontAuthenticated ? 'Authorize with Workfront' : 'Authorized'}
          </Button>
        </Col>
        <Col xs={12} md={5} className={'text-left'}>
          {workfrontAuthenticated && (
            <span
              style={{ color: `${workfrontAuthenticated ? 'green' : ''}` }}
              className={'connectionStatusText align-top'}
            >
              {'Success'}
            </span>
          )}
          {connectionFailed && (
            <span
              style={{ color: `${connectionFailed ? 'red' : ''}` }}
              className={'connectionStatusText align-top'}
            >
              {'Connection failed'}
            </span>
          )}
          {authenticationFailed && (
            <span
              style={{ color: `${authenticationFailed ? 'red' : ''}` }}
              className={'connectionStatusText align-top'}
            >
              {'Authentication failed'}
            </span>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center ">
        <Col xs={12} md={6} className={'text-center text-md-end mt-3 mt-md-0 px-4'}>
          {workfrontAuthenticated && (
            <Button
              onClick={async () => {
                await deleteCookie()
              }}
              disabled={!workfrontAuthenticated}
              className={'mondayConnectionButton'}
            >
              Disconect
            </Button>
          )}
        </Col>
        <Col xs={10} md={5} />
      </Row>

      <Row className="mt-3">
        <Col xs={6} md={5} />
        <Col
          xs={5}
          md={5}
          className="d-flex flex-wrap align-items-center justify-content-between justify-content-lg-start"
        ></Col>
      </Row>
      <Row className={'mt-5'}>
        <Col xs={10} className={'d-flex justify-content-end'}>
          <Button className={'me-4'} onClick={() => navigate('/step1')}>
            <b>Back</b>
          </Button>
          <Button
            disabled={!workfrontAuthenticated}
            onClick={() => {
              navigate('/step3')
            }}
          >
            Next
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
